module.exports = __webpack_public_path__ + "media/images/card-ef889e4cfedad80ef1bdb9299d588d80.jpg";